import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58d757ec")

_pushScopeId("data-v-58d757ec")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Classes")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_4 = { class: "page" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Portrait Full Screen")
const _hoisted_6 = { class: "video-info" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_fab = _resolveComponent("ion-fab")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button, {
                        icon: "chevron-back",
                        text: "",
                        color: "medium",
                        "default-href": "/"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { color: "medium" }, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_fab, {
        vertical: "bottom",
        horizontal: "center",
        class: ["centerme", { marginbottom: !_ctx.isWeb }]
      }, {
        default: _withId(() => [
          (!_ctx.toggleFilter)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 0,
                color: "light",
                shape: "round",
                onClick: _cache[1] || (_cache[1] = () => _ctx.openFilterModal())
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    size: "small",
                    icon: _ctx.filterCircleOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.toggleFilter)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                color: "primary",
                shape: "round",
                onClick: _cache[2] || (_cache[2] = () => _ctx.openFilterModal())
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    size: "small",
                    icon: _ctx.filterCircleOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      (!_ctx.classesLoading)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            fullscreen: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_ion_grid, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_row, { class: "border-bottom" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_row, { class: "category-icon-container" }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content.categories, (category, index) => {
                                  return (_openBlock(), _createBlock(_component_ion_col, {
                                    sizeLg: "3",
                                    sizeSm: "3",
                                    size: "3",
                                    key: category.name + index
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_card, {
                                        color: "light",
                                        class: ["category-icon-card", {
											'active-category':
												category.name == _ctx.$route.params?.categoryName,
										}],
                                        button: "",
                                        onClick: ($event: any) => (_ctx.changeCategory(category.name))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_img, {
                                            class: ["category-icon", {
												'active-category-img':
													category.name == _ctx.$route.params?.categoryName,
											}],
                                            src: category.icon
                                          }, null, 8, ["class", "src"]),
                                          _createVNode("span", {
                                            class: [{
												'active-category-text':
													category.name == _ctx.$route.params?.categoryName,
											}, "text-sm icon-text"],
                                            color: "medium"
                                          }, _toDisplayString(category.name), 3)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, { style: {"margin-top":"10px","padding-left":"5px"} }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$route.params?.categoryName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredClasses, (classObject, index) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "12",
                            "size-lg": "4",
                            "size-md": "4",
                            "size-sm": "12",
                            key: classObject?.name + index
                          }, {
                            default: _withId(() => [
                              (_ctx.isBookmarked(classObject))
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    class: "bookmarkBtn",
                                    fill: "clear",
                                    onClick: ($event: any) => (_ctx.removeBookmark(classObject))
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.bookmark,
                                        color: "light"
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 1,
                                    class: "bookmarkBtn",
                                    fill: "clear",
                                    onClick: ($event: any) => (_ctx.addBookmark(classObject))
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_icon, {
                                        color: "light",
                                        icon: _ctx.bookmarkOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])),
                              _createVNode(_component_ion_card, {
                                button: "",
                                onClick: ($event: any) => (_ctx.openModal(classObject)),
                                class: "category-card"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_badge, {
                                    color: "primary",
                                    class: "class-badge"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(classObject.isLive ? "LIVE" : "On Demand"), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (classObject?.mirror)
                                    ? (_openBlock(), _createBlock(_component_ion_badge, {
                                        key: 0,
                                        color: "light",
                                        class: "class-badge2"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_5
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_img, {
                                    src: classObject?.imgURL
                                  }, null, 8, ["src"]),
                                  _createVNode("div", _hoisted_6, [
                                    _createVNode("b", null, _toDisplayString(classObject?.duration) + " Minute " + _toDisplayString(classObject?.name), 1),
                                    _hoisted_7,
                                    _createVNode("span", _hoisted_8, _toDisplayString(classObject?.trainerData.name) + " | " + _toDisplayString(classObject?.categoryName) + " | " + _toDisplayString(_ctx.eventDate(classObject.date)), 1),
                                    (_ctx.hasProgressed(classObject))
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 0,
                                          color: "dark",
                                          class: "class-watched"
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.progressType(classObject.classID)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            fullscreen: true,
            class: "ion-text-center"
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_spinner, {
                class: "spinner",
                name: "crescent"
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
})